import type { FaireThemeEntity } from "../../entity_types/theme";

export const sleep_calm_stack: FaireThemeEntity = {
  token: "sleep-calm-stack",
  type: "theme",
  name: "Evening Rituals",
  description: "This theme increases conversion because you've already bought oral supplements (including sleep support) and calming aromatherapy spray, so you can merchandise a clear 'night routine' story and drive ",
  teaser: "You already sell the pieces -- now merchandise them as a routine.",
  detail: "Your history with oral sleep supplements and calming aromatherapy gives you the foundation for a cohesive night routine story. Bundling these into a dedicated section drives higher AOV and makes the category easier for customers to shop.",
  bgColor: "#F0D4C4",
  exactProducts: true,
  retailerToken: "r_vywa5ks4ga",
  productTokens: [
    "p_2rsqm8q8hx",
    "p_7u2tcx3m8k",
    "p_ktqfq6rzrc",
    "p_hakhzqbghs",
    "p_kagsdy7ma8",
    "p_kuxdynrtwa",
    "p_n7p2khkbjk",
    "p_wvusnmufk4",
    "p_8h42jj4dxe",
    "p_9z9dtry8gp",
    "p_npje5btpm8",
    "p_dqwcbnyrdt",
    "p_nwzfzqnzxc",
    "p_z5hy2r4ypa",
    "p_nh86w6uhqq",
    "p_xd3r5wpjwh",
    "p_bbsvgqe8qu",
    "p_gt3k2pwpqm",
    "p_7b984t9mrm",
    "p_jttyty77pe",
    "p_5xb47q633b",
    "p_p2ctth6m5y",
    "p_rjq2hz5sdd",
    "p_e7zw5fdpzh",
    "p_e39g47q543",
    "p_3xuyevs6gm",
    "p_7x5g8mswgz",
    "p_vadrxe3yzb",
    "p_qa58efmccb",
    "p_pua3j7t498",
    "p_cv7wtm7ny7",
    "p_vsngwqbuaw",
    "p_nk6yjqcds3",
    "p_e43apw2n4g",
    "p_2qcw8mc5sn",
    "p_554s5t8jjd",
    "p_crc6823aqw",
    "p_6qrt978zrg",
    "p_g2ax3jg22v",
    "p_dhrq3ncsq2",
    "p_4qtrrj2gog",
    "p_ga4qxz2z9f",
    "p_knq4rsj58d",
    "p_tub8ybxvr8",
    "p_mu6rdcq3jp",
    "p_73swt7xrer",
    "p_cxqz8atatw",
    "p_y9mdtcjh5r",
    "p_4sye5xrkaf",
    "p_9u79ht39tb",
    "p_68vynpggp3",
    "p_ahan4g43h4",
    "p_95qpz99q5v",
    "p_pc65d4q9dk",
    "p_ws3uqsb7qv",
    "p_ncsfhnagdk",
    "p_89qzhjw9yu",
    "p_8kn2ye5p2g",
    "p_fnpkp7exnn",
    "p_bvdhnqu62q",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
